import { AirClass, Amount, PaxFlights, PaxPrice } from "@ssc-booking/api-contracts"
import * as F from "fp-ts/function"
import * as O from "fp-ts/Option"
import * as ROA from "fp-ts/ReadonlyArray"
import { I18n } from "@lingui/core"
import { paxRow, ReceiptSection } from "../types"
import { airClassLabel } from "../../../app-core/_common/format/air-class-label"
import { gatewayLabel, guestLabel } from "./utils"

//**** AIR */

export const airToReceiptSection =
    (i18n_: I18n["_"], selectedGateway?: string) =>
    (paxPrice: PaxPrice): O.Option<ReceiptSection> =>
        F.pipe(
            paxPrice.details.flights,
            O.map((airPrice): ReceiptSection => {
                const { amount, airClass, isPromotional } = toAirPromoInfo(airPrice)

                return {
                    label: airClassLabel(i18n_, airClass),
                    key: "air",
                    note: selectedGateway ? gatewayLabel(selectedGateway) : undefined,
                    isPromotional: false,
                    totalAmount: O.some(amount),
                    rows: [
                        paxRow({
                            label: guestLabel(paxPrice.number),
                            isPromotional: isPromotional,
                            amount: O.some(amount),
                        }),
                    ],
                }
            }),
        )

type AirPromoInfo = {
    amount: Amount
    airClass: AirClass
    isPromotional: boolean
}

const toAirPromoInfo = (airPrice: PaxFlights): AirPromoInfo => ({
    amount: Amount.sum(airPrice.outbound.price, airPrice.return.price),
    airClass: airPrice.outbound.airClass,
    isPromotional: airPrice.outbound.isPromotional || airPrice.return.isPromotional,
})

export const isAirIncluded = (paxPrices: readonly PaxPrice[]) => {
    return F.pipe(
        paxPrices,
        ROA.map((paxPrice) =>
            F.pipe(
                paxPrice.details.flights,
                O.foldW(F.constTrue, (airPrice) =>
                    Amount.isZero(Amount.sum(airPrice.outbound.price, airPrice.return.price)),
                ),
            ),
        ),
        ROA.every(F.identity),
    )
}
